<script setup lang="ts">
defineOptions({ inheritAttrs: false });

withDefaults(defineProps<{ name: string; required?: boolean; label: string }>(), {
  required: false,
});
</script>

<template>
  <div class="flex flex-col">
    <label :for="name">
      {{ label }}
      <span v-if="required" class="i-lucide-asterisk size-3 text-primary" />
      <span v-else class="text-xs text-muted">(facultatif)</span>
    </label>
    <slot>
      <input :id="name" :name="name" :aria-required="required" :required="required" v-bind="$attrs">
    </slot>
  </div>
</template>
